export let dataProps = {
    key: 0,
    id: 0,
    category_id: null, 
    title: '',
    title_prefix: '',
    task_date: new Date(),
    task_time: '',
    assigned_to_staff_id: null,
    created_by_staff_id: null,
    description: '', 
    internal_notes: '',
    reminder_1: 0,
    reminder_2: 0,
    notify_followers: false,
    priority: 0,
    status: 0,
    task_type: 0,
    revised: false,
    revision_count: 0,
    document: '',
    followers: []
}


// WEBPACK FOOTER //
// ./src/store/modules/tasks/properties.js